export class MongoTimestamp {
  readonly seconds: number;

  readonly nanoseconds: number;

  constructor(seconds: number, nanoseconds: number) {
    this.seconds = seconds;
    this.nanoseconds = nanoseconds;
  }

  isEqual(other: MongoTimestamp): boolean {
    return this === other || (this.seconds === other.seconds && this.nanoseconds === other.nanoseconds);
  }

  toMillis(): number {
    return this.seconds * 1000 + Math.floor(this.nanoseconds / 1_000_000);
  }

  toDate(): Date {
    return new Date(this.seconds * 1000 + this.nanoseconds / 1_000_000);
  }

  static fromDate(date: Date): MongoTimestamp {
    const seconds = Math.floor(date.getTime() / 1000);
    const nanoseconds = (date.getTime() % 1000) * 1_000_000;
    return new MongoTimestamp(seconds, nanoseconds);
  }

  static now(): MongoTimestamp {
    return new MongoTimestamp(0, 0);
  }
}
